'use client';
import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';
import {useTranslation} from 'react-i18next';
import {Button, SectionTitle} from '../../primitives';
import {NearbyPlaceRow, type NearbyPlaceRowProps} from '../NearbyPlaceRow';

export interface NearbyPlacesListProps {
  places: NearbyPlaceRowProps[];
  onViewAll?: () => void;
}

// [MASTER] Nearby Locations Section mobile stacks title, map, places, button, so
// on mobile this column flattens into the section grid around the map.
const RowsColumn = styled(Box)(({theme}) => ({
  display: 'contents',
  [theme.breakpoints.up('md')]: {order: 1, display: 'flex', flexDirection: 'column', gap: theme.spacing(2)},
}));

const RowsGrid = styled(Box)(({theme}) => ({
  order: 2,
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  columnGap: 15,
  rowGap: 22,
  marginTop: theme.spacing(1),
  [theme.breakpoints.up('md')]: {columnGap: theme.spacing(4), marginTop: 0},
}));

export function NearbyPlacesList({places, onViewAll}: NearbyPlacesListProps) {
  const {t} = useTranslation();
  return (
    <RowsColumn>
      <SectionTitle tone="inverse">{t('whats_nearby')}</SectionTitle>
      <RowsGrid>
        {places.map((place, index) => (
          <NearbyPlaceRow key={`${place.label}-${index}`} {...place} color="light" />
        ))}
      </RowsGrid>
      {onViewAll && (
        <Button variant="outlined-light" onClick={onViewAll} sx={{order: 3, alignSelf: 'flex-start', justifySelf: 'start', mt: 1}}>
          {t('view_all')}
        </Button>
      )}
    </RowsColumn>
  );
}

NearbyPlacesList.displayName = 'NearbyPlacesList';
